import React, { Fragment } from 'react'
import { connect } from 'react-redux'

import { Tab, Tabs } from '@material-ui/core'
import { getCompanyFeatures } from '../../../actions/company'
import { openSuccessMessage } from '../../../actions/message'
import {
  getTaxesDisplayNames,
  saveUpdatedShop,
  updateDeliveryTaxRate,
  updateTaxesDisplayNames,
} from '../../../actions/shop'
import { getShopInformation, updateShopInformation } from '../../../actions/shopInformation'
import { getTaxTypes } from '../../../actions/taxType'
import { getConsumerTypes } from '../../../api/consumer-type'
import { isFeatureFlagEnable } from '../../../api/unleash'
import ShopSettingsWithUpdate from '../../../components/layout/ShopSettingsWithUpdate'
import TaxOption from '../../../components/TaxOption/TaxOption'
import { UnleashToggles } from '../../../types/unleashToggles'
import { getSession } from '../../../utils/api'
import ContainerWithTitleWrapper from '../../HOC/ContainerWithTitle'
import EditableHOCWrapper from '../../HOC/EditableHOC'

const TaxOptionEditable = EditableHOCWrapper(TaxOption)

class TaxOptionContainer extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: 'Cannabis',
      taxDisplayNames: [],
      lastModifiedDisplayNames: null,
      nalTaxesOnly: false,
      consumerTypes: [],
      taxTypeMapping: false,
      taxTypeOptions: [],
      isAnyEditing: false,
    }
  }
  handleAnyEdit = (isEditing) => {
    this.setState({ isAnyEditing: isEditing })
  }

  componentDidMount() {
    this.getTaxesDisplayNames()
    this.props.dispatch(getCompanyFeatures())
    this.fetchConsumerTypes()
    this.checkTaxTypeMapping()
    this.getTaxTypeOptions()
  }

  fetchConsumerTypes = async () => {
    const consumerTypes = await getConsumerTypes()
    if (consumerTypes) {
      this.setState({ consumerTypes })
    }
  }

  checkTaxTypeMapping = () => {
    isFeatureFlagEnable(UnleashToggles.TAX_TYPE_MAPPING).then((res) =>
      this.setState({ taxTypeMapping: res }),
    )
  }

  getTaxTypeOptions = () => {
    getTaxTypes().then((res) => {
      const options = res.map((item) => {
        const { taxType, displayName } = item.attributes
        return {
          value: taxType,
          label: displayName,
        }
      })

      this.setState({ taxTypeOptions: options })
    })
  }

  onSave = (data, afterOnSave) => {
    const { shop = {} } = this.props
    const { activeTab } = this.state
    if (activeTab === 'Cannabis') {
      this.props.updateShop(data).then((response) => afterOnSave(data))
    } else {
      this.props
        .updateShop({ ...shop, nonCannabisTaxes: data })
        .then((response) => afterOnSave(data))
    }
  }

  onSaveTaxAfterCityTax = (data, afterOnSave) => {
    const { shop = {} } = this.props
    const { flagisNalTaxesOnly = false } = this.props.authReducer || {}
    const changeFlagTaxAfterCityTax = shop.nalExciseAfterCityTax !== data.nalExciseAfterCityTax
    if (flagisNalTaxesOnly && changeFlagTaxAfterCityTax && data.nalExciseAfterCityTax) {
      data.taxTables.forEach((taxOption) => {
        taxOption.cityTax.activeExciseTax = false
      })
      this.props.updateShop(data).then((response) => afterOnSave(data))
      const { deliveryTaxRates = [] } = this.props.shopReducer
      deliveryTaxRates.forEach((deliveryTaxRate) => {
        if (deliveryTaxRate.useComplexTax) {
          deliveryTaxRate.taxTables.forEach((taxOption) => {
            taxOption.cityTax.activeExciseTax = false
          })
          this.props.dispatch(updateDeliveryTaxRate(deliveryTaxRate))
        }
      })
    } else {
      this.onSave(data, afterOnSave)
    }
  }

  updateShopSettings = (data, groupName) => {
    this.props.dispatch(updateShopInformation(data, groupName))
  }

  getShopSettings = (groupName) => {
    return this.props.dispatch(getShopInformation(groupName))
  }

  changeActiveTab = (e, value) => {
    this.setState({
      activeTab: value,
      isAnyEditing: false,
    })
  }

  getTaxesDisplayNames = () => {
    this.props.dispatch(getTaxesDisplayNames()).then((res) => {
      this.setState({ taxDisplayNames: res, lastModifiedDisplayNames: new Date().getTime() })
    })
  }

  updateTaxDisplayNames = (updatedTaxDisplayNames, afterSave) => {
    this.props.dispatch(updateTaxesDisplayNames(updatedTaxDisplayNames)).then((res) => {
      afterSave(res)
      console.log(res)
      const session = getSession()
      this.props.dispatch(
        saveUpdatedShop({ shop: res, session: { ...session, assignedShop: res } }),
      )
      this.props.dispatch(openSuccessMessage('Tax Display Names updated successfully'))
      this.getTaxesDisplayNames()
    })
  }

  render() {
    const { shop = {} } = this.props
    const { lastModified = null } = this.props.shopReducer
    const flagReducer = this.props.flagReducer
    const { isTaxPageEnabled = false } = flagReducer
    const {
      activeTab = 'Cannabis',
      taxDisplayNames = [],
      lastModifiedDisplayNames = null,
      consumerTypes,
      taxTypeMapping,
      taxTypeOptions,
      isAnyEditing = false,
    } = this.state
    const { nonCannabisTaxes = {} } = shop
    const { companyFeatures = {} } = this.props.companyReducer || {}
    const { flagisNalTaxesOnly = false } = this.props.authReducer || {}

    const { appTarget } = shop

    return (
      <Fragment>
        {appTarget === 'Distribution' ? (
          <TaxOptionEditable
            dataToEdit={shop || {}}
            onSave={this.onSaveTaxAfterCityTax}
            lastModified={lastModified}
            showExciseTax={true}
            isNonCannabis={activeTab === 'NonCannabis' ? true : false}
            taxDisplayNames={taxDisplayNames}
            getTaxesDisplayNames={this.getTaxesDisplayNames}
            lastModifiedDisplayNames={lastModifiedDisplayNames}
            updateTaxDisplayNames={this.updateTaxDisplayNames}
            companyFeatures={companyFeatures}
            isNalTaxesOnly={flagisNalTaxesOnly}
            updateShopSettings={this.updateShopSettings}
            getShopSettings={this.getShopSettings}
            consumerTypes={consumerTypes}
            isAnyEditing={isAnyEditing}
            handleAnyEdit={this.handleAnyEdit}
            useInternalScrollLayout={true}
          />
        ) : (
          <Fragment>
            <Tabs
              value={this.state.activeTab}
              indicatorColor="primary"
              textColor="primary"
              onChange={this.changeActiveTab}
              centered
              className="margin-bottom-small"
            >
              <Tab
                label="Cannabis Tax"
                disabled={isAnyEditing && this.state.activeTab !== 'Cannabis'}
                value="Cannabis"
              />
              <Tab
                label="Non-cannabis Tax"
                disabled={isAnyEditing && this.state.activeTab !== 'NonCannabis'}
                value="NonCannabis"
              />
            </Tabs>
            {activeTab === 'Cannabis' ? (
              <TaxOptionEditable
                dataToEdit={shop || {}}
                onSave={this.onSaveTaxAfterCityTax}
                lastModified={lastModified}
                showExciseTax={true}
                isNonCannabis={activeTab === 'NonCannabis' ? true : false}
                taxDisplayNames={taxDisplayNames}
                getTaxesDisplayNames={this.getTaxesDisplayNames}
                lastModifiedDisplayNames={lastModifiedDisplayNames}
                updateTaxDisplayNames={this.updateTaxDisplayNames}
                companyFeatures={companyFeatures}
                isNalTaxesOnly={flagisNalTaxesOnly}
                updateShopSettings={this.updateShopSettings}
                getShopSettings={this.getShopSettings}
                consumerTypes={consumerTypes}
                isTaxPageEnabled={isTaxPageEnabled}
                routing={this.props.history}
                taxTypeMapping={taxTypeMapping}
                taxTypeOptions={taxTypeOptions}
                isAnyEditing={isAnyEditing}
                handleAnyEdit={this.handleAnyEdit}
                useInternalScrollLayout={true}
              />
            ) : null}
            {activeTab === 'NonCannabis' ? (
              <TaxOptionEditable
                dataToEdit={nonCannabisTaxes || {}}
                onSave={this.onSave}
                lastModified={lastModified}
                showExciseTax={true}
                isNonCannabis={activeTab === 'NonCannabis' ? true : false}
                taxDisplayNames={taxDisplayNames}
                getTaxesDisplayNames={this.getTaxesDisplayNames}
                lastModifiedDisplayNames={lastModifiedDisplayNames}
                updateTaxDisplayNames={this.updateTaxDisplayNames}
                companyFeatures={companyFeatures}
                consumerTypes={consumerTypes}
                isTaxPageEnabled={isTaxPageEnabled}
                routing={this.props.history}
                isAnyEditing={isAnyEditing}
                handleAnyEdit={this.handleAnyEdit}
                useInternalScrollLayout={true}
              />
            ) : null}
          </Fragment>
        )}
      </Fragment>
    )
  }
}

export default connect(({ shopReducer, authReducer, dispatch, companyReducer, flagReducer }) => ({
  shopReducer,
  authReducer,
  flagReducer,
  dispatch,
  companyReducer,
}))(ShopSettingsWithUpdate(ContainerWithTitleWrapper(TaxOptionContainer, 'Tax Options')))



// WEBPACK FOOTER //
// ./src/containers/Settings/Shop/TaxOption.js